import React from 'react';
import { Button, CardContainer, Input } from '../../../components'
import Table from '../../../components/organisms/table'
import columns from './column'
import { IconImport } from '../../../assets/icons';
import { Link } from 'react-router-dom';
import { ADDTERITORIAL } from '../../../routes/routesNames';
import { UseGet } from '../../../hooks/api';
import { UseTable } from '../../../hooks';

const Teritorial = () => {    
    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
    } = UseGet('/v1/domain?type=teritori')

    const {
        isLoading : isLoadingPost ,
        dataRemove,
        handleSelected,
        handleRemove
    } = UseTable();

  return (
      <CardContainer >
            <div className="d-flex flex-row justify-content-between">
            <Input type="search" id="search" placeholder="Cari Teritori" onChange={handleFilter} />
                {
                    dataRemove.length === 0  ? 
                    <div className="d-flex flex-row">
                        {/* <Button icon={IconImport} title="Import" className="btn btn-primary-light me-3 px-4" isSmall />                 */}
                        <Link to={ADDTERITORIAL}>
                            <Button title="Tambah Teritori" className="btn btn-primary" isSmall />                
                        </Link>
                    </div>
                    : 
                    <Button 
                        isLoading={isLoadingPost === 'loading'} 
                        onClick={() =>  handleRemove('/v1/domain/delete')}  
                        title="Hapus Teritori" 
                        className="btn btn-danger" isSmall />                
                }
            </div>
            <Table 
                filter={filter}
                isLoading={isLoading}
                error={error}
                data={data}
                totalPages={totalPages}
                handlePagination={handlePagination}
                handleLimit={handleLimit}
                handleChangeSelect={handleSelected} 
                columns={columns} 
                isUpdate={filter.isUpdate} />
      </CardContainer>
  )
}

export default Teritorial